import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import axios from 'axios'

Vue.use(Vuex)

const session = {
  namespaced: true,

  state: () => ({
    session: {
      access: '',
      refresh: '',
      user: '',
      selected_laboratory: '',
    },
    lab_settings: null,
    customization_loading: false,
    localStorage: false
  }),

  mutations: {
    SET_SESSION_DATA(state, data) {
      const session = {
        access: data.access ? data.access : data.access,
        refresh: data.refresh,
        user: data.user,
      }
      state.session = session

      if (!data.alreadyLoaded) {
        state.localStorage = data.remember
        // Clear any stale lab profile that may belong to a previous user
        localStorage.removeItem('user_lab_profile')
        sessionStorage.removeItem('user_lab_profile')
        if (data.remember) {
          localStorage.setItem('session', JSON.stringify(session))
        } else {
          sessionStorage.setItem('session', JSON.stringify(session))
        }
        // console.log(this.commit)
        // dispatch('session/setSelectedCompany', data.selected_company)

      }
    },

    CLEAR_SESSION_DATA(state) {
      // state.user = null
      state.localStorage = true,

      sessionStorage.removeItem('session')
      localStorage.removeItem('session')
      localStorage.removeItem('user_lab_profile')
      sessionStorage.removeItem('user_lab_profile')
      sessionStorage.removeItem('lab_settings')
      localStorage.removeItem('lab_settings')
    },

    REFRESH_TKN(state, data) {
      state.session.access = data.access
      localStorage.setItem('session', JSON.stringify(state.session))
    },

    SET_LABORATORY(state, lab) {
      state.session.selected_laboratory = lab
      localStorage.setItem('user_lab_profile', JSON.stringify(lab))
      sessionStorage.setItem('user_lab_profile', JSON.stringify(lab))
    },
    SET_LABORATORY_SETTINGS(state, settings) {
      state.lab_settings = settings
      localStorage.setItem('lab_settings', JSON.stringify(settings))
      sessionStorage.setItem('lab_settings', JSON.stringify(settings))
    },
    SET_CUSTOMIZATION_LOADING(state, value) {
      state.customization_loading = value
    },
  },

  actions: {
    setSessionData({ commit }, session_data) {
      commit('SET_SESSION_DATA', session_data)
    },
    logoutUser({ commit }) {
      commit('CLEAR_SESSION_DATA')
    },
    async setUserLabProfile({ commit }, lab) {
      commit('SET_LABORATORY', lab)
      return Promise.resolve()
    },
    async setLabSettings({ commit }, settings) {
      commit('SET_LABORATORY_SETTINGS', settings)
    },
    setCustomizationLoading({ commit }, value) {
      commit('SET_CUSTOMIZATION_LOADING', value)
    },
  },

  getters: {
    logged: (state) => () => { return !!state.session },
    get_token: (state) => () => { return state.session?.access },
    refresh: (state) => () => { return state.session?.refresh },
    userData: (state) => () => { return state.session?.user },
    labSettings: (state) => () => { return state.lab_settings },
    customizationLoading: (state) => () => state.customization_loading,
    getUserRole: (state) => () => {
      const selectedLab = state.session.selected_laboratory
      const profiles = state.session.user?.laboratory_profiles || []

      const profile = profiles.find(p => p.laboratory_slug === selectedLab?.laboratory_slug)

      return profile?.role ?? null
    },

    selectedLaboratory: (state) => () => {
      return state.session?.selected_laboratory || false
    },
  },
}


export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    session: session,
  },
})

